import React from 'react';
import styled from 'styled-components';

const LockerHistoryColumnView = () => {

  return (
    <TopLevelWrapper>
      <Column style={{marginRight: '152px', marginLeft: '28px'}}>락커번호</Column>
      <Column style={{marginRight: '106px'}}>사용 기간</Column>
      <Column style={{marginRight: '50px'}}>사용일수</Column>
      <Column style={{marginRight: '70px'}}>상태</Column>
      <Column style={{marginRight: '144px'}}>이용금액</Column>
      <Column>락커 결제일</Column>
    </TopLevelWrapper>
  )
}

export default LockerHistoryColumnView;

const TopLevelWrapper = styled.div`
  display: flex;
  flex-direction: row;

  // justify-content: center;
  
  // justify-content: center;
  align-items: center;

  width: 1020px;
  margin-top: 34px;
  margin-bottom: 20px;
  
  transition: all 0.3s ease-in-out;
`;

const Column = styled.p`
  font-family: NotoSansKR-Medium;
  font-size: 14px;

  color: #232323;

  margin: 0 0 0 0;
`;
